import { render, staticRenderFns } from "./CardTransmision.vue?vue&type=template&id=d08b673a&scoped=true&"
import script from "./CardTransmision.vue?vue&type=script&lang=js&"
export * from "./CardTransmision.vue?vue&type=script&lang=js&"
import style0 from "./CardTransmision.vue?vue&type=style&index=0&id=d08b673a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08b673a",
  null
  
)

export default component.exports